import { useOutletContext } from 'react-router-dom';

import { LegalAgreementHtmlBlock } from '../widget-ui/legal-agreement-html-block';
import { formatISODate } from '../widget-lib/format-date';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';
import type { LegalDocumentsOutletContext } from './legal_LegalDocumentsOutlet';

export default function LegalOrganizationPage() {
  useWidgetSeo(
    'Реквизиты и оферта организации',
    'Юридическая информация, реквизиты организации и договор оферты.'
  );
  const { data } = useOutletContext<LegalDocumentsOutletContext>();
  const html = data.OrgUserAgreementText;
  if (html == null || html === '') {
    return (
      <article className="space-y-4 w-full min-w-0 px-4 py-4">
        <h1 className="text-xl font-semibold tracking-tight">Соглашение с организацией</h1>
        <p className="text-sm text-[var(--text-muted)]">
          Текст доступен при открытии приложения по ссылке с контекстом организации (студии).
        </p>
      </article>
    );
  }
  return (
    <article className="space-y-4 w-full min-w-0 px-4 py-4">
      <h1 className="text-xl font-semibold tracking-tight">Соглашение с организацией</h1>
      {data.OrgUserAgreementDate && (
        <p className="text-xs text-[var(--text-muted)]">от {formatISODate(data.OrgUserAgreementDate)}</p>
      )}
      <LegalAgreementHtmlBlock html={html} />
    </article>
  );
}
